import { PromQLExtension } from '@prometheus-io/codemirror-promql';
import { EditorState } from '@codemirror/state';
import { Decoration, EditorView, ViewPlugin, keymap } from '@codemirror/view';
import { autocompletion, startCompletion, closeBrackets, completionKeymap } from '@codemirror/autocomplete';
import { StreamLanguage, syntaxHighlighting, defaultHighlightStyle } from '@codemirror/language';
import { classHighlighter } from '@lezer/highlight';
import { shell } from '@codemirror/legacy-modes/mode/shell';

const ShellLanguage = StreamLanguage.define(shell);

export {
  PromQLExtension,
  EditorState,
  Decoration,
  EditorView,
  ViewPlugin,
  keymap,
  autocompletion,
  startCompletion,
  closeBrackets,
  completionKeymap,
  StreamLanguage,
  syntaxHighlighting,
  defaultHighlightStyle,
  classHighlighter,
  ShellLanguage,
};
